import React, { useCallback, useEffect, useState } from "react";
import { Button, Form, Grid, Header, Input, InputOnChangeData, Label, Segment } from "semantic-ui-react";
import { toast } from "react-toastify";

import TemplateMain from "../../components/TemplateMain";
import errors, { IAliancaErrors, IApiError } from "../../Utils/ExtractErrors";
import UsuarioRepository from "../../Repositories/UsuarioRepository";
import { eStatus, IUsuario } from "../../interfaces";
import { GetUser, Login } from "../../services/auth";
import { Redirect, RouteComponentProps, withRouter } from "react-router-dom";

interface State extends IUsuario {
    apiErrors: IAliancaErrors;
    loading: boolean;
    saving: boolean;
    novaSenha: string;
    confirmacao: string;
    redirect: boolean;
}
type PathParamsType = {};

type Props = RouteComponentProps<PathParamsType> & {};

const initialState: State = {
    id: "",
    nome: "",
    login: "",
    senha: "",
    referenceId: "",
    userLevel: "Revendedor",
    status: eStatus.Pendente,
    trocaSenha: true,
    apiErrors: { errors: [] },
    loading: false,
    saving: false,
    novaSenha: "",
    confirmacao: "",
    redirect: false
}

const ChangePassword = (props: Props) => {

    const [state, setState] = useState<State>(initialState);

    const { id } = GetUser();

    const loadUser = useCallback(async function () {
        const response = await UsuarioRepository.GetById(id);
        setState(state => ({
            ...state,
            ...response,
            senha: ""
        }));
    }, [id]);

    function hasError(key: string) {
        return errors.hasError(state.apiErrors, key);
    }

    function getMessage(key: string) {
        return errors.getMessage(state.apiErrors, key);
    }

    function handleOnChange(event: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) {
        const { name, value } = data;
        setState(state => ({ ...state, [name]: value }));
    }

    async function handleOnSubmit() {
        let formErrors: IApiError[] = [];

        if (state.senha.length === 0) {
            formErrors.push({ key: "Senha", message: "O campo senha atual é obrigatório" });
        }
        if (state.novaSenha.length === 0) {
            formErrors.push({ key: "NovaSenha", message: "O campo nova senha é obrigatório" });
        }
        if (state.confirmacao.length === 0) {
            formErrors.push({ key: "Confirmacao", message: "O campo confirmação é obrigatório" });
        }
        if (formErrors.length > 0) {
            return setState(state => ({ ...state, apiErrors: { errors: formErrors } }));
        } else {
            try {
                setState(state => ({ ...state, apiErrors: { errors: formErrors }, saving: true }));
                const response = await UsuarioRepository.Update({
                    id: id,
                    nome: state.nome,
                    login: state.login,
                    senha: state.senha,
                    novaSenha: state.novaSenha,
                    confirmacao: state.confirmacao,
                    userLevel: state.userLevel,
                    status: state.status,
                    trocaSenha: false
                });

                const responseLogin = await UsuarioRepository.LogIn({
                    login: state.login,
                    senha: state.novaSenha
                });

                Login(responseLogin.token);
                props.history.push("/app");

                toast(response.message, { position: "top-center", type: "success" });
            } catch (err) {
                if (err.response.status === 401) {
                    window.location.href = "/";
                }
                setState(state => ({ ...state, apiErrors: err.response.data, saving: false }));
            }
        }
    }

    useEffect(() => {
        loadUser();
    }, [loadUser]);

    useEffect(() => {
        const error = errors.getErrors({ errors: state.apiErrors.errors }, "ApiError");
        if (error !== undefined) {
            toast(error, { position: "top-center", type: "error" });
        }
    }, [state.apiErrors]);

    const content = (
        !state.redirect
            ? <Grid columns="1" verticalAlign="middle" textAlign="center">
                <Grid.Row>
                    <Grid.Column textAlign="left">
                        <Header dividing size="huge">
                            Troca de senha obrigatória
                    </Header>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column textAlign="left" style={{ maxWidth: 600 }}>
                        <Segment>
                            <Header dividing size="large">
                                Preencha os dados abaixo
                            </Header>
                            <Form>
                                <Form.Field error={hasError("Senha")} required>
                                    <label>Senha atual</label>
                                    <Input
                                        name="senha"
                                        placeholder="Senha atual"
                                        value={state.senha}
                                        type="password"
                                        onChange={handleOnChange}
                                    />
                                    {hasError("Senha") && <Label pointing prompt>{getMessage("Senha")}</Label>}
                                </Form.Field>
                                <Form.Field error={hasError("NovaSenha")} required>
                                    <label>Nova senha</label>
                                    <Input
                                        name="novaSenha"
                                        placeholder="Nova senha"
                                        value={state.novaSenha}
                                        type="password"
                                        onChange={handleOnChange}
                                    />
                                    {hasError("NovaSenha") && <Label pointing prompt>{getMessage("NovaSenha")}</Label>}
                                </Form.Field>
                                <Form.Field error={hasError("Confirmacao")} required>
                                    <label>Confirmar nova senha</label>
                                    <Input
                                        name="confirmacao"
                                        placeholder="Confirmação"
                                        value={state.confirmacao}
                                        type="password"
                                        onChange={handleOnChange}
                                    />
                                    {hasError("Confirmacao") && <Label pointing prompt>{getMessage("Confirmacao")}</Label>}
                                </Form.Field>
                                <Button
                                    fluid
                                    color="pink"
                                    content="Alterar senha"
                                    loading={state.saving}
                                    onClick={handleOnSubmit}
                                />
                            </Form>
                        </Segment>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            : <Redirect to="/" />
    )

    return (
        <TemplateMain
            loading={false}
            content={content}
        />
    );
}

export default withRouter(ChangePassword);
